<template>
  <div class="of_header">
    <div class="logo">
      <img src="../assets/images/logo.png" alt="logo">
    </div>
    <div class="navbar">
      <ul class="navbar_list">
        <li class="navbar_item" :class="{ active:this.$route.path=='/index' }">
          <router-link to="/index">{{$t('lang.header_index')}}</router-link>
        </li>
        <li
          class="navbar_item item_list"
          :class="{ active:this.$route.path=='/about'||this.$route.path=='/project'||this.$route.path=='/friend'||this.$route.path=='/people' }"
        >
          <a>{{$t('lang.header_about')}}</a>
          <span class="icon_down"></span>
          <div class="item_list_dropdown">
            <li class="item_list_item" :class="{ active:this.$route.path=='/project' }">
              <router-link to="/project">{{$t('lang.header_project')}}</router-link>
            </li>
            <li class="item_list_item" :class="{ active:this.$route.path=='/friend' }">
              <router-link to="/friend">{{$t('lang.header_friend')}}</router-link>
            </li>
            <!-- <li class="item_list_item" :class="{ active:this.$route.path=='/people' }">
              <router-link to="/people">{{$t('lang .header_people')}}</router-link>
            </li> -->
          </div>
        </li>
        <li class="navbar_item" :class="{ active:this.$route.path=='/news' }">
          <router-link to="/news">{{$t('lang.header_news')}}</router-link>
        </li>
        <li class="navbar_item" :class="{ active:this.$route.path=='/ceo' }">
          <router-link to="/ceo">{{$t('lang.header_memo')}}</router-link>
        </li>
        <li class="navbar_item" v-on:click="changeLang">
          <a>{{$t('lang.header_lang')}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    changeLang: function() {
      if (this.$i18n.locale === "zh-CN") {
        this.$i18n.locale = "en-US";
      } else {
        this.$i18n.locale = "zh-CN";
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/global.less";
.of_header {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  padding: 0 80px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 16px rgba(194, 194, 194, 0.16);
  @media screen and (max-width: 768px) {
    padding: 0 10px;
  }
  .logo {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    img {
      width: 149px;
      height: 48px;
      line-height: 100px;
    }
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .navbar {
    .navbar_list {
      .navbar_item {
        display: inline-block;
        list-style: none;
        padding: 0 50px;
        .icon_down {
          display: inline-block;
          margin-left: 8px;
          width: 12px;
          height: 17px;
          background: url("../assets/images/arrow_down.png") center no-repeat;
          background-size: inherit;
          transition: all 0.4s ease-in-out;
        }
        a {
          line-height: 100px;
          font-size: 20px;
          display: inline-block;
          color: @textcolor;
          &:hover {
            color: @blue;
          }
        }
        @media screen and (max-width: 1200px) {
          padding: 0 40px;
          a {
            line-height: 80px;
          }
        }
        @media screen and (max-width: 900px) {
          padding: 0 25px;
          a {
            line-height: 70px;
            font-size: 18px;
          }
        }
        @media screen and (max-width: 768px) {
          padding: 0 10px;
          a {
            line-height: 60px;
            font-size: 14px;
          }
        }
      }
      .active {
        a {
          color: @blue;
        }
      }
      .item_list {
        position: relative;
        .item_list_dropdown {
          position: absolute;
          left: -10px;
          overflow: auto;
          padding: 5px 0;
          width: 200px;
          text-align: center;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 8px 16px rgba(168, 168, 168, 0.16);
          opacity: 0;
          height: 0;
          border-radius: 4px;
          -webkit-transition: all 0.2s ease-in-out;
          transition: all 0.2s ease-in-out;
          @media screen and (max-width: 768px) {
            width: 150px;
            left: -20px;
            .item_list_item {
              a {
                font-size: 14px;
              }
            }
          }
          .item_list_item {
            padding: 10px 15px;
            a {
              font-size: 18px;
              line-height: 20px;
              color: @textcolor;
              &:hover {
                color: @blue;
              }
              @media screen and (max-width: 768px) {
                font-size: 14px;
              }
            }
          }
          .active {
            a {
              color: @blue;
            }
          }
        }
        &:hover {
          .item_list_dropdown {
            opacity: 0.8;
            height: auto;
          }
          .icon_down {
            margin-top: 5px;
            background: url("../assets/images/arrow_top.png") center no-repeat;
            background-size: inherit;
            transform: rotate(360deg);
          }
        }
      }
    }
  }
}
</style>
